import { render } from "./Notification.vue?vue&type=template&id=ad645150&scoped=true&ts=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=ad645150&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad645150"]])

export default __exports__